<label
  class="relative flex w-full items-center gap-2 cursor-pointer overflow-hidden p-2 rounded hover:bg-secondary-100"
  (click)="triggerClick() ; $event.stopPropagation()"
>
  <input
    type="radio"
    class="cursor-pointer accent-primary-500"
    [value]="corpValue"
            (input)="onInput($event)"
            (blur)="onTouched()"
            [disabled]="disabled || corpLoading"
            [readonly]="corpReadonly"
  />

  <span>{{ value.label }}</span>

  @if(activeLaser){
    <span
    
        class="absolute top-0 left-0 h-full w-full pointer-events-none"
    >
        <span class="laser"></span>
    </span>
  }
  
</label>
